import {IconName} from "../utils";

export const PATH = {
  HOME: '/',
  LOGIN: '/dang-nhap',
  ONBOARDING: '/onboarding',
  STORE_INFO: '/thong-tin-cua-hang',
  MANAGING_PRODUCT: '/quan-ly-san-pham',
  CREATE_PRODUCT: '/tao-san-pham',
  ADDRESS: '/so-dia-chi',
  SHIPPING_CONFIG: '/cau-hinh-van-chuyen',
  EDIT_PRODUCT: '/chinh-sua-san-pham',
  MANAGING_ORDER: '/quan-ly-don-hang',
  ACCOUNT_SETTING: '/quan-ly-tai-khoan',
  CHANGE_PASSWORD: '/doi-mat-khau',
  SHARE: '/chia-se',
  BUYER_MANAGEMENT_CART_DETAIL: '/quan-ly-don-hang/order',
  NOTIFICATION: '/thong-bao',
}

/** Chuỗi trạng thái đơn (API / URL ?status=). Import: `import { ORDER_STATUS } from 'constants'` */
export const ORDER_STATUS = {
  ORDER_CREATED: 'order_created',
  SELLER_CONFIRM: 'seller_confirm',
  SYSTEM_PROCESS: 'system_process',
  SELLER_PROCESSING: 'seller_processing',
  SELLER_PREPARED: 'seller_prepared',
  SHIPPING_PROCESSING: 'shipping_processing',
  SHIPPING_DONE: 'shipping_done',
  ORDER_COMPLETE: 'order_complete',
  ORDER_CANCEL: 'order_cancel',
  ORDER_REFUND: 'order_refund',
}

/** Một số API / timeline có thể trả alias (tracker). */
export const ORDER_STATUS_ALIAS = {
  DELIVERED: 'delivered',
  RETURNED: 'returned',
}

/** Pending (không gồm order_created) — khớp OrderDetails */
export const ORDER_STATUS_PENDING = [
  ORDER_STATUS.SELLER_CONFIRM,
  ORDER_STATUS.SYSTEM_PROCESS,
  ORDER_STATUS.SELLER_PROCESSING,
  ORDER_STATUS.SELLER_PREPARED,
]

/** Pending gồm order_created — khớp OrderGroup */
export const ORDER_STATUS_PENDING_WITH_CREATED = [
  ORDER_STATUS.ORDER_CREATED,
  ...ORDER_STATUS_PENDING,
]

export const ORDER_STATUS_DELIVERED = [
  ORDER_STATUS.SHIPPING_DONE,
  ORDER_STATUS.ORDER_COMPLETE,
]

export const STATUS = {
  STATUS_SHIPPING_PROCESSING: ORDER_STATUS.SHIPPING_PROCESSING,
}


export const VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  OUTLINE: 'outline',
  GRADIENT: 'gradient',
  CUSTOM: 'custom',
  ACTIVE: 'active',
  CUSTOM_MOBILE: 'custom-mobile',
}


export const FIELD_BUSINESS = [
  {code: 1, name: 'Kinh doanh nông sản thô'},
  {code: 2, name: 'Chế biến và kinh doanh sản phẩm từ nông sản'},
  {code: 3, name: 'Kinh doanh giống cây trồng, vật nuôi'},
  {code: 4, name: 'Kinh doanh vật tư nông nghiệp'},
  {code: 5, name: 'Kinh doanh sản phẩm thủy sản'},
  {code: 6, name: 'Kinh doanh lâm sản và sản phẩm từ rừng'},
  {code: 7, name: 'Kinh doanh sản phẩm nông sản hữu cơ, sạch'},
  {code: 8, name: 'Kinh doanh đặc sản vùng miền'},
  {code: 9, name: 'Dịch vụ liên quan đến nông nghiệp'},
  {code: 10, name: 'Kinh doanh sản phẩm thủ công từ nông sản'},
  {code: 11, name: 'Chăn nuôi và cung cấp sản phẩm chăn nuôi'},
  {code: 12, name: 'Kinh doanh phân bón hữu cơ và sản phẩm tái chế từ nông nghiệp'},
  {code: 13, name: 'Khác'}
]

export const ERROR_MESSAGE = {
  ERROR: 'Có lỗi xảy ra. Vui lòng thử lại.',
  ERROR_UPLOAD_FILES: 'Có lỗi xảy ra khi cập nhật Giấy tờ khác',
  ERROR_UPLOAD_AVATAR: 'Có lỗi xảy ra khi cập nhật ảnh đại diện',
}

export const PRODUCT_STATUS = {
  ALL: 'all',
  DRAFT: 'draft',
  PROPOSED: 'proposed',
  PUBLISHED: 'published',
  REJECTED: 'rejected',
  PENDING: 'pending',
}

export const STATUS_TABS = [
  {id: 0, status: PRODUCT_STATUS.ALL, title: "Tất cả", count: 0,},
  {id: 1, status: PRODUCT_STATUS.PUBLISHED, title: "Đang hiển thị", count: 0,},
  {id: 2, status: PRODUCT_STATUS.DRAFT, title: "Đang chờ duyệt", count: 0,},
  {id: 3, status: PRODUCT_STATUS.PROPOSED, title: "Đã ẩn", count: 0,},
  {id: 4, status: PRODUCT_STATUS.REJECTED, title: "Bị từ chối", count: 0,},
];

export const LOCAL_STORAGE_KEY = {
  TOKEN: 'token',
  REFRESH_TOKEN: 'refreshToken',
  CART_STORAGE_KEY: 'selected_cart_items',
  ORDER_STORAGE_KEY: 'order-data'
}

export const CONFIG_URL = {
  POLICY: '/files/dieukhoan.pdf',
  SECURITY: '/files/chinhsach.pdf',
  FUTA_EXPRESS: 'https://futaexpress.vn/',
  FUTA_BUSLINES: 'https://futabus.vn/',
  GOOPAY: 'https://goopay.vn/',
}

export const METADATA_VALUE = {
  YES: 'yes'
}

export const LinkApp = {
  IOS: 'https://apps.apple.com/vn/app/futa-funong/id6738379606',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.futa.funong&pli=1'
}
export const STATUS_ORDERS = [
  {value: ORDER_STATUS.SELLER_CONFIRM, name: 'Chờ xác nhận'},
  {value: ORDER_STATUS.ORDER_CREATED, name: 'Chờ xác nhận'},
  {value: ORDER_STATUS.SYSTEM_PROCESS, name: 'Chờ xác nhận'},
  {value: ORDER_STATUS.SELLER_PROCESSING, name: 'Chờ xác nhận'},
  {value: ORDER_STATUS.SELLER_PREPARED, name: 'Chờ xác nhận'},
  {value: ORDER_STATUS.SHIPPING_PROCESSING, name: 'Đang vận chuyển'},
  {value: ORDER_STATUS.SHIPPING_DONE, name: 'Giao thành công'},
  {value: ORDER_STATUS.ORDER_COMPLETE, name: 'Giao thành công'},
  {value: ORDER_STATUS.ORDER_CANCEL, name: 'Đơn bị huỷ'},
  {value: ORDER_STATUS.ORDER_REFUND, name: 'Đơn hoàn/ trả'},
]

export const STATUS_ICONS = {
  [ORDER_STATUS.ORDER_CREATED]: IconName.documents,
  [ORDER_STATUS.SELLER_CONFIRM]: IconName.confirm,
  [ORDER_STATUS.SELLER_PREPARED]: IconName.confirm,
  [ORDER_STATUS.SYSTEM_PROCESS]: IconName.confirm,
  [ORDER_STATUS.SELLER_PROCESSING]: IconName.confirm,
  [ORDER_STATUS.SHIPPING_PROCESSING]: IconName.delivery,
  [ORDER_STATUS.SHIPPING_DONE]: IconName.check,
  [ORDER_STATUS.ORDER_CANCEL]: IconName.canceled,
  [ORDER_STATUS.ORDER_REFUND]: IconName.returned,
}
export const STATUS_TITLES = {
  [ORDER_STATUS.ORDER_CREATED]: 'Chờ xác nhận',
  [ORDER_STATUS.SELLER_CONFIRM]: 'Đã xác nhận',
  [ORDER_STATUS.SELLER_PREPARED]: 'Bàn giao cho nhà vận chuyển',
  [ORDER_STATUS.SYSTEM_PROCESS]: 'Chờ xác nhận',
  [ORDER_STATUS.SELLER_PROCESSING]: 'Đang xử lý',
  [ORDER_STATUS.SHIPPING_PROCESSING]: 'Đang vận chuyển',
  [ORDER_STATUS.SHIPPING_DONE]: 'Giao hàng thành công',
  [ORDER_STATUS.ORDER_COMPLETE]: 'Giao hàng thành công',
  [ORDER_STATUS.ORDER_CANCEL]: 'Đơn bị huỷ',
  [ORDER_STATUS.ORDER_REFUND]: 'Hoàn/Trả hàng',
  [ORDER_STATUS_ALIAS.DELIVERED]: 'Giao hàng thành công',
  [ORDER_STATUS_ALIAS.RETURNED]: 'Hoàn/Trả hàng',
}


export const CONFIG_IMAGE = {
  MOBILE: {
    HOME: '/img/mobile/Home.png',
    HOME_ACTIVE: '/img/mobile/home-active.png',
    NEWSPAPER: '/img/mobile/Newspaper.png',
    NEWSPAPER_ACTIVE: '/img/mobile/News-active.png',
    STORE: '/img/mobile/store.png',
    USER: '/img/mobile/user.png',
    USER_ACTIVE: '/img/mobile/user-active.png',
    STORE_ACTIVE: '/img/mobile/store.png',
    ABSTRACT: '/img/mobile/abstract.png',
    avatarMobile: '/img/mobile/avatar-mobile.png',
    avatarUserProfile: '/img/mobile/user-profile.png',
    chat: '/img/icon/chat-support.png',
    errorOutline: '/img/mobile/error_outline.svg',
    delivery: '/img/mobile/delivery.svg',
    orderCancel: '/img/mobile/order-cancel.svg',
    orderReturn: '/img/mobile/order-return.svg',
    setup: '/img/mobile/setup.svg',
    shippingDone: '/img/mobile/shipping-done.svg',
  }
}

export const ICON_MOBILE_ORDER_STATUS = {
  [ORDER_STATUS.ORDER_CREATED]: CONFIG_IMAGE.MOBILE.setup,
  [ORDER_STATUS.SELLER_CONFIRM]: CONFIG_IMAGE.MOBILE.setup,
  [ORDER_STATUS.SELLER_PREPARED]: CONFIG_IMAGE.MOBILE.setup,
  [ORDER_STATUS.SYSTEM_PROCESS]: CONFIG_IMAGE.MOBILE.setup,
  [ORDER_STATUS.SELLER_PROCESSING]: CONFIG_IMAGE.MOBILE.setup,
  [ORDER_STATUS.SHIPPING_PROCESSING]: CONFIG_IMAGE.MOBILE.delivery,
  [ORDER_STATUS.SHIPPING_DONE]: CONFIG_IMAGE.MOBILE.shippingDone,
  [ORDER_STATUS.ORDER_CANCEL]: CONFIG_IMAGE.MOBILE.orderCancel,
  [ORDER_STATUS.ORDER_REFUND]: CONFIG_IMAGE.MOBILE.orderReturn,
}
